/* Display variant images */

function showVariantImage(ev) {
  const productId = ev.target.dataset.product;
  const variantId = ev.target.dataset.variant;
  const variantSku = ev.target.dataset.sku;
  const variantBadge = ev.target.dataset.variantBadges;
  const variantBadgePosition = ev.target.dataset.badgePosition;

  // loop over all product card images and make them opaque, except for the selected one
  const cardImages = document.querySelectorAll(`.product-card-${productId} .card-product-image`)
    
  if (cardImages.length > 1 ) {
    cardImages.forEach((img) => {
      const imgVariantId = img.dataset.variant;

      if (imgVariantId === variantId) {
        img.classList.remove('image-hover');
        img.classList.add('image-variant-hover');
      } else {
        img.classList.add('image-hover');
        img.classList.remove('image-variant-hover');
      }
    });
  }

  // update the SKU and the anchor link of selected variant 
  const productCard = document.querySelector(`.product-card-${productId}`); 

  if (productCard) {
    const variantSkuValue = productCard.querySelector('.product__sku .sku');
    const variantLink = productCard.querySelectorAll('.full-unstyled-link.main-link');

    if (variantSkuValue) {
      variantSkuValue.innerHTML = variantSku;
    }

    if (variantLink) {
      variantLink.forEach((link) => {
        const productUrl = link.dataset.cardHandle;
        const variantUrl = productUrl + '?variant=' + variantId;
        link.setAttribute('href', variantUrl);
      });
    };
  }

  //display the variant badges
  plpDisplayVariantBadges(variantBadge, variantBadgePosition, productCard);
}

function hideVariantImage(ev) {
  const productId = ev.target.dataset.product;
  const variantId = ev.target.dataset.variant;

  // loop over all product card images and make them opaque, except for the selected one
  document.querySelectorAll(`.product-card-${productId} .card-product-image)`).forEach((img) => {
    if (img.dataset.secondaryImage) {
      return;
    }

    const imgVariantId = img.dataset.variant;

    if (imgVariantId === variantId) {
      img.classList.remove('image-variant-hover');
    } else {
      img.classList.remove('image-hover');
    }
  });
}

document.querySelectorAll('.card-variant--container .color-swatch').forEach((card) => {
  card.addEventListener('click', showVariantImage);
  // card.addEventListener('mouseleave', hideVariantImage);
});

document.addEventListener('as:grid-render', (evt) => {
  const $cards = document.querySelectorAll('.product-card-wrapper')
  $cards.forEach((card) => {
    const input = card.querySelector('.swatch-input[checked]')
    const label = card.querySelector(`label[for="${input.id}"]`)
    const variantBadge = label.dataset.variantBadges;
    const variantBadgePosition = label.dataset.badgePosition;
    plpDisplayVariantBadges(variantBadge, variantBadgePosition, card);
  });
})

/* Apply tag filters via toggle switch */

function applyFilter(ev) {
  const toggleURL = ev.target.dataset.toggleUrl;

  // either a metafield-based toggle or tag-based toggle
  if (toggleURL !== "") {
    location.href = `${toggleURL}`;
  } else {
    const filterTag = ev.target.dataset.tag;
    const currentCollection = ev.target.dataset.collection;
    const currentTags = ev.target.dataset.currentTags;
    const loc = document.location;
    const currentPathName = loc.pathname;
    let newPathName = '';
    let newUrl = '';

    // remove or add tag from URL
    if (ev.target.checked) {
      let newTags = `${currentTags}+${filterTag}`;
      newTags = newTags.replace('++', '+');
      newPathName = `/collections/${currentCollection}/${newTags}`;
      newPathName = newPathName.replace('/+', '/');
    } else {
      newPathName = currentPathName.replace(filterTag, '');
      newPathName = newPathName.replace('++', '+');
      newPathName = newPathName.replace('/+', '/');
    }

    newUrl = `${loc.protocol}//${loc.host}${newPathName}${loc.search}`;
    location.href = newUrl;
  }
}

domReady(() => {
  document.querySelectorAll('.filter-toggle').forEach((toggle) => {
    toggle.addEventListener('change', applyFilter);
  });
});

/* Close availability menu when clicking outside */

function closeAvailabilityMenu(ev) {
  document.querySelectorAll('.details-availability').forEach((menu) => {
    menu.removeAttribute('open');
  });
}

function removeAvailabilityMenu() {
  document.querySelectorAll('.availability-checkbox').forEach((check) => {
    if (check.classList.contains('mobile-facets__checkbox')) return;
    check.removeEventListener('change', closeAvailabilityMenu);
  });
}

function setupAvailabilityMenu() {
  document.body.addEventListener('click', closeAvailabilityMenu);

  document.querySelectorAll('.availability-checkbox').forEach((check) => {
    if (check.classList.contains('mobile-facets__checkbox')) return;
    check.addEventListener('change', closeAvailabilityMenu);
  });
}

domReady(() => {
  if (window.innerWidth >= 1240) {
    setupAvailabilityMenu();
  }
});

window.addEventListener('resize', debounce((event) => {
  if (window.innerWidth >= 1240) {
    setupAvailabilityMenu();
  } else {
    removeAvailabilityMenu();
  }
}, 300).bind(this));

//Init product card variant to first variant
function InitProductCardVariant() {
  const swatchContainers = document.querySelectorAll('.card-variant--container');
  setTimeout(() => {
    swatchContainers.forEach((card) => {
      // Temporarily disable page scrolling during click operation
      const originalScrollX = window.scrollX; // Store the current scroll position
      const originalScrollY = window.scrollY; // Store the current scroll position

      const options = card.querySelectorAll('.swatch-input');
      options.forEach((option) => {
        if (option.checked) {
          const option_id = option.id;
          const option_label = card.querySelector(`label[for="${option_id}"]`);
          option_label.click();
        };
      });
      // Re-enable page scrolling after click operation
      window.scrollTo(originalScrollX, originalScrollY);
	  })
  }, 500);
}
domReady(InitProductCardVariant);

const plpDisplayVariantBadges = (variantBadge, variantBadgePosition, productCard) => {
  // Remove existing js added badges
  const existingJsBadges = productCard.querySelectorAll('.js-card__badge');
  if (existingJsBadges) {
    existingJsBadges.forEach((badge) => {
      badge.remove();
    });
  };
  //Add new badges
  if (!variantBadge) return;
  const variantBadgeArray = variantBadge.split(',');
  const badgeContainer = productCard.querySelector('.card__badge--container');
  const badgeAcount = badgeContainer.querySelectorAll('.card__badge--container .card__badge').length;
  if (badgeAcount >=  2) return;
  for (let i = badgeAcount; i < 2; i++) {
    if (variantBadgeArray[i]) {
      const badge = `
        <div class="card__badge js-card__badge ${variantBadgePosition}">
          <span class="badge badge--bottom-left color-background-2">${variantBadgeArray[i]}</span>
        </div>`;
      badgeContainer.insertAdjacentHTML('beforeend', badge);
    };
  };
};
